import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";

const styles = createUseStyles((theme) => ({
  modalHeaderWrapper: {
    marginLeft: "23px",
    "& h3": {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      color: colors.lightBlack,
      marginBottom: "8px",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      margin: "0px",
    },
  },
  unsavedChangesModal: {
    width: "544px",
    "& .modal-header": {
      alignItems: "flex-start",
      padding: "24px 24px 16px 24px",
      "& div:first-child": {
        flexShrink: 0,
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "27px",
        right: "27px",
      },
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: "8px 24px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    },
  },
  unsavedChangesModalWrapper: {
    "--bs-modal-width": "544",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  btnContainer: {
    marginBottom: "16px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
  },
  cancelBtn: {
    height: "100%",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px",
    fontFamily: theme.fontFamily,
    width: "fit-content",
  },
  saveBtn: {
    height: "100%",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px",
    fontFamily: theme.fontFamily,
    width: "fit-content",
  },
}));

export default styles;
